module.exports = function() {
  return new Worker(__webpack_public_path__ + "0e8afc28d687e4fed837.worker.js");
};